import React from "react";
import "../Navigation/css/NavBar.scss";
import {Black, Blue3} from "../../theme/styles";
import supplier_004_delete_employee_request_1 from '../../json/supplier/supplier-004-delete-employee-request-1.json';
import supplier_004_delete_group_request_1 from '../../json/supplier/supplier-004-delete-group-request-1.json';
import supplier_002_delete_group_response_1 from '../../json/supplier/supplier-002-delete-group-response-1.json';
import supplier_002_delete_employee_response_1 from '../../json/supplier/supplier-002-delete-employee-response-1.json';

import ReactJson from 'react-json-view'
import {Accordion, AccordionDetails, AccordionSummary, Avatar, Typography} from "@mui/material";
import {ExpandMore} from "@mui/icons-material";

export default function SuppliersDelete() {

    return (
        <div style={{paddingLeft: "20px", paddingRight: "30px"}}>
            <p style={{fontSize: "24px", fontWeight: "400", color: Black}}>Suppliers DELETE</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Overview</p>

            <p style={{fontSize: "14px", fontWeight: "400", color: Black, marginLeft: "20px"}}>
                In Enlil, the Suppliers DELETE API allows for the deletion of supplier related information. Suppliers themselves may not be deleted.
            </p>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Parameters</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>Header Parameters
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>X-Enlil-AccessToken (Required String)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The X-Enlil-AccessToken is obtained during the authentication process and expires after 90 days.</li>
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>X-Enlil-RefreshToken (Optional String)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The X-Enlil-RefreshToken is obtained during the authentication process and never expires. This token is provided is the caller wants a refreshed X-Enlil-AccessToken</li>
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>idoc-request (Required String: must equal v1.Supplier-004)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The name of the IDOC being specified in the DELETE request.</li>
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>idoc-response (Optional String).</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>v1.Supplier-001, v1.Supplier-002, v1.Supplier-003, and v1.Supplier-004 are permitted values.</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>If idoc-response is provided, the response payload (HTTP Code: 201) will match the specified format, else no response (HTTP Code: 204) will be provided.</li>
                </li>
            </ul>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Scenarios</p>
            <p style={{fontSize: "14px", fontWeight: "400", color: Black, marginLeft: "20px"}}>
                <Accordion style={{backgroundColor: "#EEEEEE"}}>
                    <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1-content" id="panel1-header">
                        <Avatar sx={{marginTop: "2px", bgcolor: Blue3, width: 25, height: 25, fontSize: "14px", marginRight: "10px"}}>1</Avatar>
                        <Typography style={{paddingTop: "3px"}}><b>Removing a group from a Supplier</b></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p style={{marginLeft: "20px"}}>
                            <span style={{lineHeight: "1.5em"}}>A group may be removed from a Supplier through the use of the /t3/v1/suppliers DELETE API. The following payload may be used to perform the delete operation.</span>
                        </p>
                        <p style={{fontFamily: "Courier New", fontSize: "12px", marginLeft: "20px"}}>
                            <ReactJson src={supplier_004_delete_group_request_1} collapseStringsAfterLength={75} collapsed={4}/>
                        </p>
                        <li style={{marginTop: "20px", marginLeft: "20px"}}>The following is a representative response.</li>
                        <br/>
                        <p style={{fontFamily: "Courier New", fontSize: "12px", marginLeft: "20px"}}>
                            <ReactJson src={supplier_002_delete_group_response_1} collapseStringsAfterLength={75} collapsed={4}/>
                        </p>
                        <br/>
                    </AccordionDetails>
                </Accordion>
                <Accordion style={{backgroundColor: "#EEEEEE"}}>
                    <AccordionSummary expandIcon={<ExpandMore/>} aria-controls="panel1-content" id="panel1-header">
                        <Avatar sx={{marginTop: "2px", bgcolor: Blue3, width: 25, height: 25, fontSize: "14px", marginRight: "10px"}}>2</Avatar>
                        <Typography style={{paddingTop: "3px"}}><b>Removing an employee from a Supplier</b></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p style={{marginLeft: "20px"}}>
                            <span style={{lineHeight: "1.5em"}}>An employee may be removed to a Supplier through the use of the /t3/v1/suppliers DELETE API. The following payload may be used to perform the delete operation.</span>
                        </p>
                        <p style={{fontFamily: "Courier New", fontSize: "12px", marginLeft: "20px"}}>
                            <ReactJson src={supplier_004_delete_employee_request_1} collapseStringsAfterLength={75} collapsed={4}/>
                        </p>
                        <li style={{marginTop: "20px", marginLeft: "20px"}}>The following is a representative response.</li>
                        <br/>
                        <p style={{fontFamily: "Courier New", fontSize: "12px", marginLeft: "20px"}}>
                            <ReactJson src={supplier_002_delete_employee_response_1} collapseStringsAfterLength={75} collapsed={4}/>
                        </p>
                        <br/>
                    </AccordionDetails>
                </Accordion>
            </p>
        </div>
    )
}